import CityIcon from '@assets/images/city-emoji.png';
import DoorIcon from '@assets/images/door-emoji.png';
import HomeIcon from '@assets/images/home-emoji.png';
import HouseImg from '@assets/images/house.avif';
import KeyImg from '@assets/images/key.avif';
import TravelImg from '@assets/images/luggage.avif';
import PetIcon from '@assets/images/pet-emoji.png';
import PetImg from '@assets/images/pet.avif';
import SportImg from '@assets/images/sneakers.avif';
import SportIcon from '@assets/images/sport-emoji.png';
import VaseImg from '@assets/images/vase.avif';
import type { TFunction } from 'i18next';

import {
  CREATE_SUBSCRIPTION,
  LANDING_PAGE_APARTMENT,
  LANDING_PAGE_HOUSE,
  LANDING_PAGE_PETS,
  LANDING_PAGE_SPORT,
  SRG_LINK,
} from '../constants';
import { Product, ProductCode } from '../types';

type ProductCodeFiltered = Exclude<
  ProductCode,
  ProductCode.MORTGAGE | ProductCode.NS | ProductCode.TRAVEL | ProductCode.MITE
>;

export const PRODUCT_ICON_MAP = {
  [ProductCode.APARTMENT]: CityIcon,
  [ProductCode.HOUSE]: HomeIcon,
  [ProductCode.PETS]: PetIcon,
  [ProductCode.SPORT]: SportIcon,
  [ProductCode.MORTGAGE]: DoorIcon,
};

export const PRODUCT_LINK_MAP = {
  [ProductCode.APARTMENT]: `${CREATE_SUBSCRIPTION}?product=${Product.APARTMENT}`,
  [ProductCode.HOUSE]: `${CREATE_SUBSCRIPTION}?product=${Product.HOUSE}`,
  [ProductCode.PETS]: `${CREATE_SUBSCRIPTION}?product=${Product.PETS}`,
  [ProductCode.SPORT]: `${CREATE_SUBSCRIPTION}?product=${Product.SPORT}`,
  [ProductCode.MORTGAGE]: SRG_LINK,
};

export const PRODUCT_LANDING_LINK_MAP: Record<ProductCodeFiltered, string> = {
  [ProductCode.APARTMENT]: LANDING_PAGE_APARTMENT,
  [ProductCode.HOUSE]: LANDING_PAGE_HOUSE,
  [ProductCode.PETS]: LANDING_PAGE_PETS,
  [ProductCode.SPORT]: LANDING_PAGE_SPORT,
};

export const getProducts = (
  t: TFunction
): {
  productCode: ProductCodeFiltered;
  productName: string;
  description: string;
}[] => [
  {
    productCode: ProductCode.APARTMENT,
    productName: t('PRODUCTS:products.flat'),
    description: t('PRODUCTS:descriptions:flat'),
  },
  {
    productCode: ProductCode.HOUSE,
    productName: t('PRODUCTS:products.house'),
    description: t('PRODUCTS:descriptions:house'),
  },
  {
    productCode: ProductCode.PETS,
    productName: t('PRODUCTS:products.pet'),
    description: t('PRODUCTS:descriptions:pet'),
  },
  {
    productCode: ProductCode.SPORT,
    productName: t('PRODUCTS:products.sport'),
    description: t('PRODUCTS:descriptions:sport'),
  },
];

export const PRODUCT_IMG_MAP = {
  [ProductCode.APARTMENT]: VaseImg,
  [ProductCode.HOUSE]: HouseImg,
  [ProductCode.PETS]: PetImg,
  [ProductCode.SPORT]: SportImg,
  [ProductCode.TRAVEL]: TravelImg,
  [ProductCode.MORTGAGE]: KeyImg,
};
